import * as z from 'zod'
import { CarEquipmentTypeEnum } from '~/shared/config/enums'
import { dateSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const attributesSchema = z.object({
  title: z.string(),
  type: z.nativeEnum(CarEquipmentTypeEnum),
  equipmentId: z.string(),
  value: z.boolean(),
})

const schema = z
  .object({
    createdAt: dateSchema,
    updatedAt: dateSchema,
  })
  .merge(attributesSchema)

export type CarEquipmentAttributes = z.infer<typeof schema>

export class CarEquipment extends ApiModel<
  typeof schema,
  CarEquipmentAttributes
> {
  static jsonApiType = 'car-equipments'

  static schema = schema
}
